(function(){
  'use strict';

  function qs(root, sel){ return root ? root.querySelector(sel) : null; }
  function qsa(root, sel){ return Array.prototype.slice.call(root ? root.querySelectorAll(sel) : []); }
  function norm(v){ return String(v || '').toLowerCase().replace(/[™®]/g,'').replace(/[^a-z0-9]+/g,' ').trim(); }
  function optValue(btn){ return btn ? (btn.getAttribute('data-option-value') || btn.textContent || '').trim() : ''; }
  function isMobile(){ return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches); }

  function visibleGroups(root){
    return qsa(root,'[data-studio-group]').filter(function(group){
      if(group.hidden || group.closest('[data-studio-branch][hidden]')) return false;
      /* Locked/read-only groups are summaries, not editable flow steps.
         They must not become the next mobile-focused accordion, otherwise
         BandWare PDP can end on an invisible/empty controls state. */
      if(group.classList && group.classList.contains('studio__group--locked')) return false;
      if(group.hasAttribute && group.hasAttribute('data-studio-flow-skip')) return false;
      var interactive = qsa(group,'[data-studio-option], [data-studio-toggle]').some(function(el){
        return !el.hidden && !el.closest('[hidden]') && !el.disabled;
      });
      var options = qs(group,'[data-studio-options]');
      return interactive || !!(options && options.children && options.children.length);
    });
  }

  function groupIsComplete(root, group){
    if(!group) return false;
    var names=[];
    qsa(group,'[data-studio-option]').forEach(function(btn){
      if(btn.hidden || btn.closest('[hidden]')) return;
      var name=btn.getAttribute('data-option-name');
      if(name && names.indexOf(name)===-1) names.push(name);
    });
    return names.every(function(name){
      return !!qsa(group,'[data-studio-option][data-option-name="'+name+'"]')
        .find(function(btn){ return btn.classList.contains('is-selected') || btn.getAttribute('aria-selected')==='true'; });
    });
  }

  function studioScroller(root){
    return qs(root,'.studio__body') || qs(root,'[data-studio-body]') || qs(root,'.studio__controls') || root;
  }

  function resetStudioScroll(root){
    if(!root || !isMobile()) return;
    var scroller=studioScroller(root);
    window.setTimeout(function(){
      try{
        if(scroller && scroller.scrollTo) scroller.scrollTo({top:0,behavior:'auto'});
        else if(scroller) scroller.scrollTop=0;
      }catch(e){ try{ if(scroller) scroller.scrollTop=0; }catch(ignore){} }
    }, 0);
  }

  function scrollGroupIntoView(controller, group){
    if(!group || !isMobile()) return;
    var root=controller && controller.root ? controller.root : document;
    var scroller=studioScroller(root);
    window.setTimeout(function(){
      try{
        if(scroller && scroller.scrollTo && scroller.getBoundingClientRect && group.getBoundingClientRect){
          var delta=group.getBoundingClientRect().top - scroller.getBoundingClientRect().top + (scroller.scrollTop || 0) - 8;
          scroller.scrollTo({top:Math.max(0,delta),behavior:'smooth'});
          return;
        }
        if(group.scrollIntoView) group.scrollIntoView({block:'start',inline:'nearest',behavior:'smooth'});
      }catch(e){
        try{ if(group.scrollIntoView) group.scrollIntoView(true); }catch(ignore){}
      }
    }, 80);
  }

  function closeGroup(root, group){
    if(!group) return;
    group.setAttribute('data-open','false');
    var options=qs(group,'[data-studio-options]');
    var summary=qs(group,'[data-studio-summary]');
    if(options) options.hidden=true;
    if(summary) summary.setAttribute('aria-expanded','false');
    group.classList.remove('is-mobile-focused');
    if(root && root.classList && !qs(root,'[data-studio-group][data-open="true"]')) root.classList.remove('studio-mobile-focus');
  }

  function clearMobileFocus(root){
    qsa(root,'[data-studio-group]').forEach(function(group){ group.classList.remove('is-mobile-focused'); });
    if(root && root.classList) root.classList.remove('studio-mobile-focus');
    resetStudioScroll(root);
  }

  function normalizeMobileFocus(root){
    if(!root || !root.classList || !root.classList.contains('studio-mobile-focus')) return;
    var active=qs(root,'[data-studio-group].is-mobile-focused:not([hidden])');
    if(active && !(active.closest('[data-studio-branch]') && active.closest('[data-studio-branch]').hidden)) return;
    clearMobileFocus(root);
  }

  function closeFinalGroup(controller, group){
    if(!group) return;
    var root=controller && controller.root ? controller.root : document;
    closeGroup(root, group);
    /* Shared final-state rule: on mobile, closing the final editable group must
       leave the accordion list available, never an empty focused body. */
    if(isMobile()) clearMobileFocus(root);
    else clearMobileFocus(root);
  }

  function openGroup(controller, group){
    var root=controller && controller.root ? controller.root : document;
    if(!group || group.hidden) return;
    qsa(root,'[data-studio-group]').forEach(function(candidate){
      candidate.setAttribute('data-open','false');
      var options=qs(candidate,'[data-studio-options]');
      var summary=qs(candidate,'[data-studio-summary]');
      if(options) options.hidden=true;
      if(summary) summary.setAttribute('aria-expanded','false');
      candidate.classList.remove('is-mobile-focused');
    });
    group.setAttribute('data-open','true');
    var activeOptions=qs(group,'[data-studio-options]');
    var activeSummary=qs(group,'[data-studio-summary]');
    if(activeOptions) activeOptions.hidden=false;
    if(activeSummary) activeSummary.setAttribute('aria-expanded','true');
    group.classList.add('is-mobile-focused');
    if(root && root.classList) root.classList.add('studio-mobile-focus');
  }

  function frameTypeNeedsFinish(controller, option){
    var root=controller && controller.root ? controller.root : document;
    var value=optValue(option) || (controller && controller.state && controller.state.frameType) || '';
    if(norm(value)==='clear') return false;
    var block=qs(root,'[data-studio-frame-finish-block]');
    if(block && block.hidden) return false;
    return qsa(root,'[data-studio-option][data-option-name="frameFinish"]').some(function(btn){
      return !btn.hidden && !btn.disabled && !btn.closest('[hidden]');
    });
  }

  function shouldAutoAdvance(controller, option){
    var optionName=option && option.getAttribute ? (option.getAttribute('data-option-name') || '') : '';
    if(!optionName) return false;

    /* Pairing is two-part. Apple Watch / Royal Pop only chooses the branch.
       Direct / WatchWare completes the pairing group. */
    if(optionName==='device') return false;

    /* Frame type only completes immediately when there is no finish step.
       Clear has no finish and can complete immediately. Carbon and similar
       frame types wait for Finish. */
    if(optionName==='frameType' && frameTypeNeedsFinish(controller, option)) return false;

    /* WatchWare line exposes finish choices. Completion happens at finish. */
    if(optionName.indexOf('watchwareLine-')===0) return false;

    /* BandWare options remain open for testing. */
    if(optionName==='bandware' || optionName==='bandMaterial' || optionName==='material') return false;

    return true;
  }

  function advanceToNext(controller, group, option){
    if(!controller || !group) return;
    var root=controller.root || document;
    var groupKey=group.getAttribute('data-group') || '';
    var optionName=option && option.getAttribute ? (option.getAttribute('data-option-name') || '') : '';

    if(groupKey==='pairing' && optionName!=='mode') return;

    var current=groupKey ? qs(root,'[data-studio-group][data-group="'+groupKey+'"]') : group;
    current=current || group;
    if(!groupIsComplete(root, current)) return;

    var groups=visibleGroups(root);
    var idx=groups.indexOf(current);
    if(idx<0){ normalizeMobileFocus(root); return; }
    var next=groups[idx+1];
    if(!next){ closeFinalGroup(controller, current); return; }

    openGroup(controller, next);
    scrollGroupIntoView(controller, next);
  }

  function scheduleAutoAdvance(controller, option, delay){
    if(!shouldAutoAdvance(controller, option)) return;
    var root=controller && controller.root ? controller.root : document;
    var optionName=option && option.getAttribute ? (option.getAttribute('data-option-name') || '') : '';
    var group=option && option.closest ? option.closest('[data-studio-group]') : null;
    if(!group && optionName.indexOf('watchwareFinish-')===0){
      var kind=optionName.split('-')[1] || (controller && controller.state && controller.state.device==='royal-pop' ? 'royal' : 'apple');
      group=qs(root,'[data-studio-group][data-group="'+(kind==='royal'?'watchware-royal':'watchware')+'"]');
    }
    if(!group) return;
    var groupKey=group.getAttribute('data-group') || '';
    window.setTimeout(function(){
      var current=groupKey ? qs(root,'[data-studio-group][data-group="'+groupKey+'"]') : group;
      advanceToNext(controller, current || group, option);
    }, delay == null ? 120 : delay);
  }

  function advanceAfterWatchwareFinish(controller, option){
    var optionName=option && option.getAttribute ? (option.getAttribute('data-option-name') || '') : '';
    if(optionName.indexOf('watchwareFinish-')!==0) return false;
    var root=controller && controller.root ? controller.root : document;
    var kind=optionName.split('-')[1] || (controller && controller.state && controller.state.device==='royal-pop' ? 'royal' : 'apple');
    var groupKey=kind==='royal' ? 'watchware-royal' : 'watchware';
    window.setTimeout(function(){
      var group=qs(root,'[data-studio-group][data-group="'+groupKey+'"]') || (option.closest ? option.closest('[data-studio-group]') : null);
      if(!group) return;
      advanceToNext(controller, group, option);
    }, 140);
    return true;
  }

  function install(proto){
    if(!proto) return;
    proto.visibleGroups=function(){ return visibleGroups(this.root || document); };
    proto.groupIsComplete=function(group){ return groupIsComplete(this.root || document, group); };
    proto.scrollNextGroupIntoView=function(group){ return scrollGroupIntoView(this, group); };
    proto.closeGroup=function(group){ return closeGroup(this.root || document, group); };
    proto.isMobileViewport=isMobile;
    proto.clearMobileFocus=function(){ return clearMobileFocus(this.root || document); };
    proto.normalizeMobileFocus=function(){ return normalizeMobileFocus(this.root || document); };
    proto.resetStudioScroll=function(){ return resetStudioScroll(this.root || document); };
    proto.closeFinalGroup=function(group){ return closeFinalGroup(this, group); };
    proto.closeMobileFocusForFinalStep=function(group){ return closeFinalGroup(this, group); };
    proto.openGroup=function(group){ return openGroup(this, group); };
    proto.frameTypeNeedsFinish=function(option){ return frameTypeNeedsFinish(this, option); };
    proto.shouldAutoAdvance=function(option){ return shouldAutoAdvance(this, option); };
    proto.advanceAfterWatchwareFinish=function(option){ return advanceAfterWatchwareFinish(this, option); };
    proto.openNextGroup=function(group, option){ return advanceToNext(this, group, option); };
    proto.scheduleAutoAdvance=function(option){ return scheduleAutoAdvance(this, option); };
    proto.__brilintonStudioFlowInstalled=true;
  }

  function collectionModeStart(instance){
    if(!instance) return '';
    if(instance.mode === 'watchware') return instance.isRoyal ? 'royal-model' : 'watchware';
    return instance.isRoyal ? 'royal-model' : 'apple-size';
  }

  function collectionNextGroup(instance, completedStep){
    if(!instance) return '';
    if(completedStep === 'appleSize' && instance.mode === 'direct' && !instance.isRoyal) return 'link';
    if(completedStep === 'royalModel' && instance.isRoyal) return instance.mode === 'watchware' ? 'watchware' : 'frame';
    if(completedStep === 'mode') return collectionModeStart(instance);
    return '';
  }

  window.BrilintonStudioFlow={
    install:install,
    visibleGroups:visibleGroups,
    groupIsComplete:groupIsComplete,
    shouldAutoAdvance:shouldAutoAdvance,
    frameTypeNeedsFinish:frameTypeNeedsFinish,
    openGroup:openGroup,
    closeFinalGroup:closeFinalGroup,
    scheduleAutoAdvance:scheduleAutoAdvance,
    advanceAfterWatchwareFinish:advanceAfterWatchwareFinish,
    collectionModeStart:collectionModeStart,
    collectionNextGroup:collectionNextGroup
  };
})();
